export default {
    props: {
        immutablesDeserialization: {
            type: Function,
            default: undefined,
            kComposite: 'immutables.deserialization'
        }, 
        immutablesSerialization: {
            type: [String, Function],
            default: undefined,
            kComposite: 'immutables.serialization'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/Immutables.js